import { Component } from '@angular/core';

@Component({
  selector: 'umkt-slug-redirect',
  standalone: true,
  template: '<div></div>',
})
export class SlugRedirectComponent {}

